import type { CSSProperties } from "react";
import { useMemo } from "react";
import "./index.css";
import type { IDividerProps } from "./types";
import { clsx } from "clsx";
import { Typography } from "../Typography";
import { pxToRem } from "../../utils";

export const Divider = ({
  text,
  direction = "horizontal",
  width,
  height,
  className,
}: IDividerProps) => {
  const rootClass: string = clsx(
    "nuco-divider",
    `nuco-divider--${direction}`,
    className,
  );

  const style: CSSProperties = useMemo(() => {
    const dimensions: CSSProperties = {};

    if (width !== undefined) {
      dimensions.width = pxToRem(width);
    }

    if (height !== undefined) {
      dimensions.height = pxToRem(height);
    }

    return dimensions;
  }, [width, height]);

  return (
    <div className={rootClass} style={style}>
      {text && <Typography className="nuco-divider__text" text={text} />}
    </div>
  );
};
